export default __webpack_public_path__ + "static/media/santa.5f5e05f0.svg";